export const apiRouter = {
  // AUTH
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',

  // USER
  GET_ALL_USERS: '/user',
  GET_USER_BY_ID: '/user/:id',
  DELETE_USER_BY_ID: '/user/:id',
  UPDATE_PROFILE: '/user/:id/updateProfile',
  CREATE_USER: '/user/createUser',
  GET_USER_PASSWORD: '/user/getUserPassword/:userId',
  WITHDRAW_FUND: '/user/withdrawFund/:userId',

  // FUND
  GET_FUND_DETAIL_BY_ID: '/fund/:userId',
  CREATE_OR_UPDATE_FUND: '/fund/createOrUpdate',

  // INSTRUCTION
  CREATE_OR_UPDATE_OR_GET_INSTRUCTION: '/instruction',

  // TRADE
  CREATE_TRADE_DETAIL: '/trade',
  UPDATE_TRADE_DETAIL: '/trade/:id',
  DELETE_TRADE_DETAIL: '/trade/:id',
  GET_TRADE_DETAILS_BY_USER_ID: '/trade/user/:userId',

  // TRANSACTION
  CREATE_TRANSACTION: '/transaction',
  UPDATE_TRANSACTION: '/transaction/:id',
  DELETE_TRANSACTION: '/transaction/:id',
  GET_TRANSACTION_BY_USER_ID: '/transaction/user/:userId',
};
